import { render } from "./manufacturer-single.vue?vue&type=template&id=0bd646a0&scoped=true"
import script from "./manufacturer-single.vue?vue&type=script&lang=js"
export * from "./manufacturer-single.vue?vue&type=script&lang=js"

import "./manufacturer-single.vue?vue&type=style&index=0&id=0bd646a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd646a0"]])

export default __exports__